/**
 * Notify When Available Button Handler
 * Plain JavaScript - no module dependencies
 */

// Prevent script from running multiple times
if (window.__NotifyWhenAvailableInitialized) {
  // Script already initialized, skip
  if (window.NotifyWhenAvailable && typeof window.NotifyWhenAvailable.updateButtonVisibility === 'function') {
    // Re-run updateButtonVisibility if needed
    setTimeout(() => {
      window.NotifyWhenAvailable.updateButtonVisibility();
    }, 100);
  }
} else {
  // Mark as initialized
  window.__NotifyWhenAvailableInitialized = true;

  // Track when we just clicked the button to prevent immediate dimming
  let justClickedNotifyButton = false;
  let clickTimestamp = 0;

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
  const notifyButton = document.getElementById('BIS_trigger');
  const addToCartButton = document.querySelector('[name="add"]');
  const addToCartContainer = document.querySelector('add-to-cart-component');

  if (!notifyButton) {
    return;
  }

  // Add click handler to ensure BIS_frame is visible before app handles the click
  // The app (AMP Back in Stock) should handle the click natively on #BIS_trigger
  // We just ensure the iframe is visible so the pop-up can display
  notifyButton.addEventListener('click', function(e) {
    // Set flag to prevent dimming for the next few seconds
    justClickedNotifyButton = true;
    clickTimestamp = Date.now();
    
    // Clear the flag after 10 seconds (give pop-up plenty of time to stay open)
    setTimeout(() => {
      justClickedNotifyButton = false;
    }, 10000);
    
    // Ensure BIS_frame iframe is visible (needed for pop-up to display)
    // ONLY touch BIS_frame - don't affect other iframes (like Gorgias chat widget)
    const bisFrame = document.getElementById('BIS_frame');
    if (bisFrame) {
      bisFrame.style.display = '';
      bisFrame.style.visibility = '';
      bisFrame.style.opacity = '';
      bisFrame.removeAttribute('data-hidden-by-notify-script');
    }
    
    // Also ensure floating button is visible (in case app needs it)
    // Be very specific - only target the back-in-stock floating button
    const floatingButton = document.querySelector('.bis-rotate-90:not(iframe), .bis-edge-left:not(iframe)');
    if (floatingButton && floatingButton.tagName === 'DIV' && floatingButton.id !== 'BIS_trigger') {
      // Check it's actually the back-in-stock button, not something else
      const hasNotifyText = (floatingButton.textContent || '').toUpperCase().includes('NOTIFY') ||
                           (floatingButton.textContent || '').toUpperCase().includes('BACK IN STOCK');
      if (hasNotifyText) {
        floatingButton.style.opacity = '1';
        floatingButton.style.pointerEvents = 'auto';
        floatingButton.style.display = 'block';
        floatingButton.style.visibility = 'visible';
        floatingButton.removeAttribute('data-dimmed-by-notify-script');
      }
    }
    
    // Don't prevent default or stop propagation - let the app handle everything
    // The app should detect the click on #BIS_trigger and open the pop-up
  }, false);

  // Set up a MutationObserver to keep BIS_frame iframe visible
  // BUT: Only restore if we're NOT in the middle of a click (to avoid interfering with pop-up)
  const bisFrame = document.getElementById('BIS_frame');
  if (bisFrame && bisFrame instanceof Node) {
    let restoreTimeout = null;
    let lastRestoreTime = 0;
    const MIN_RESTORE_INTERVAL = 2000; // Only restore once per 2 seconds max
    
    const frameObserver = new MutationObserver(function(mutations) {
      // Verify bisFrame is still in the DOM before accessing it
      if (!document.contains(bisFrame)) {
        frameObserver.disconnect();
        return;
      }
      
      // Don't interfere if we just clicked the button (pop-up might be opening)
      const timeSinceClick = Date.now() - clickTimestamp;
      if (justClickedNotifyButton && timeSinceClick < 10000) {
        return; // Don't restore during the 10 seconds after clicking
      }
      
      // Debounce to avoid excessive calls
      if (restoreTimeout) {
        clearTimeout(restoreTimeout);
      }
      
      restoreTimeout = setTimeout(() => {
        // Double-check element is still valid
        if (!document.contains(bisFrame)) {
          frameObserver.disconnect();
          return;
        }
        
        const now = Date.now();
        // Throttle restorations to avoid interfering with the app
        if (now - lastRestoreTime < MIN_RESTORE_INTERVAL) {
          return;
        }
        
        const currentDisplay = window.getComputedStyle(bisFrame).display;
        const currentVisibility = window.getComputedStyle(bisFrame).visibility;
        
        // Only restore if it's actually hidden (display: none or visibility: hidden)
        // AND we're not in the middle of a click
        if ((currentDisplay === 'none' || currentVisibility === 'hidden') && !justClickedNotifyButton) {
          // Check if pop-up might be open (iframe has src or is in a visible container)
          const parent = bisFrame.parentElement;
          const parentDisplay = parent ? window.getComputedStyle(parent).display : 'block';
          const parentVisibility = parent ? window.getComputedStyle(parent).visibility : 'visible';
          
          // Only restore if parent is also visible (pop-up container is active)
          if (parentDisplay !== 'none' && parentVisibility !== 'hidden') {
            bisFrame.style.display = '';
            bisFrame.style.visibility = '';
            bisFrame.style.opacity = '';
            bisFrame.removeAttribute('data-hidden-by-notify-script');
            lastRestoreTime = now;
          }
        }
      }, 200); // Longer delay to batch mutations and avoid interference
    });
    
    try {
      frameObserver.observe(bisFrame, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: false,
        subtree: false
      });
    } catch (e) {
      console.error('NotifyWhenAvailable: Failed to observe BIS_frame', e);
    }
  }

  // Set initial state based on add to cart button (IMMEDIATE)
  updateButtonVisibility();
  
  // Move floating button off-screen when in-line button is visible
  // Do this asynchronously to not block initial render
  requestAnimationFrame(() => {
    requestAnimationFrame(() => { // Double RAF to ensure DOM is ready
      const notifyButton = document.getElementById('BIS_trigger');
      if (notifyButton && notifyButton.style.display !== 'none' && !notifyButton.classList.contains('hidden')) {
        hideFloatingNotifyButtons();
      }
    });
  });

  // Listen for variant changes - try multiple event types
  document.addEventListener('variant:change', handleVariantChangeEvent);
  
  // Listen for variant:update events (from VariantUpdateEvent) - crucial for quick add modal
  document.addEventListener('variant:update', handleVariantUpdateEvent);
 
  // Listen for variant picker changes
  const variantPickers = document.querySelectorAll('variant-picker-component');
  variantPickers.forEach(picker => {
    picker.addEventListener('change', handleVariantPickerChange);
  });

  // Listen for any form changes on the product form
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    const variantInput = productForm.querySelector('input[name="id"]');
    if (variantInput) {
      // Listen for immediate input changes (fires instantly when value changes)
      variantInput.addEventListener('input', () => {
        updateButtonVisibility();
      }, { passive: true });

      // Use MutationObserver to watch for variant ID attribute changes
      // Use debouncing to avoid excessive calls, but update immediately
      let pendingUpdate = false;
      let updateTimeout = null;
      const observer = new MutationObserver(() => {
        // Verify variantInput is still in the DOM before using it
        if (!document.contains(variantInput)) {
          observer.disconnect();
          return;
        }
        
        if (!pendingUpdate) {
          pendingUpdate = true;
          // Clear any pending timeout
          if (updateTimeout) {
            clearTimeout(updateTimeout);
          }
          // Update immediately for faster response
          updateButtonVisibility();
          // Reset flag after a brief moment to allow rapid changes
          updateTimeout = setTimeout(() => {
            pendingUpdate = false;
          }, 50);
        }
      });

      try {
        if (variantInput instanceof Node) {
          observer.observe(variantInput, {
            attributes: true,
            attributeFilter: ['value']
          });
        }
      } catch (e) {
        console.error('NotifyWhenAvailable: Failed to observe variant input', e);
      }
    }
  }

  // Also listen for clicks on variant options
  const variantOptions = document.querySelectorAll('[name^="option"]');
  variantOptions.forEach(option => {
    option.addEventListener('change', () => {
      // Update immediately for faster response
      updateButtonVisibility();
    });
  });
  }

  function handleVariantChangeEvent(event) {
  if (event.detail && event.detail.variant) {
    updateButtonVisibility(event.detail.variant);
  } else {
    updateButtonVisibility();
  }
  }

  function handleVariantUpdateEvent(/** @type {any} */ event) {
  // Handle VariantUpdateEvent from the theme (crucial for quick add modal)
  if (event.detail && event.detail.resource) {
    // Pass the event target to help find the correct context (modal vs main page)
    updateButtonVisibility(event.detail.resource, event.target);
  } else {
    updateButtonVisibility();
  }
  }
  
  function handleVariantPickerChange(/** @type {any} */ event) {
  // Update immediately for faster response
  updateButtonVisibility();
  }

  function hideFloatingNotifyButtons() {
  // Make floating button nearly invisible but keep it in original position
  // BUT: Don't interfere if pop-up is currently open
  // IMPORTANT: Only touch BIS_frame and back-in-stock elements - never touch Gorgias chat widget
  
  // FIRST: Check if pop-up is open (BIS_frame has content or is in visible container)
  const bisFrame = document.getElementById('BIS_frame');
  let popupIsOpen = false;
  
  if (bisFrame) {
    // Preserve and restore ONLY the BIS_frame iframe (needed for pop-up)
    // Don't touch any other iframes - this was causing Gorgias chat widget to reposition
    bisFrame.style.display = '';
    bisFrame.style.visibility = '';
    bisFrame.style.opacity = '';
    bisFrame.removeAttribute('data-hidden-by-notify-script');
    
    // Check if pop-up appears to be open
    const frameDisplay = window.getComputedStyle(bisFrame).display;
    const frameVisibility = window.getComputedStyle(bisFrame).visibility;
    const frameSrc = bisFrame.src || bisFrame.getAttribute('src');
    const parent = bisFrame.parentElement;
    const parentDisplay = parent ? window.getComputedStyle(parent).display : 'block';
    const parentVisibility = parent ? window.getComputedStyle(parent).visibility : 'visible';
    
    // Pop-up is likely open if iframe is visible and has a src, or parent is visible
    popupIsOpen = (frameDisplay !== 'none' && frameVisibility !== 'hidden' && frameSrc && frameSrc !== 'about:blank') ||
                  (parentDisplay !== 'none' && parentVisibility !== 'hidden');
  }
  
  // ONLY restore BIS_frame iframe - don't touch other iframes (like Gorgias chat widget)
  // Restoring all iframes was causing the chat widget to reposition incorrectly
  // We only need to ensure BIS_frame is visible for the pop-up
  
  // If pop-up is open OR we just clicked the button, DON'T dim the floating button
  const timeSinceClick = Date.now() - clickTimestamp;
  if (popupIsOpen || (justClickedNotifyButton && timeSinceClick < 5000)) {
    return;
  }
  
  // Make floating button nearly invisible but keep it in place and functional
  try {
    const floatingButtonContainers = document.querySelectorAll('.bis-rotate-90, .bis-edge-left');
    
    floatingButtonContainers.forEach(container => {
      // Skip iframes completely
      if (container.tagName === 'IFRAME') {
        return;
      }
      // Skip elements with BIS_frame id
      if (container.id === 'BIS_frame' || container.id === 'bis_frame') {
        return;
      }
      // Skip our in-line button
      if (container.id === 'BIS_trigger' || container.closest('#BIS_trigger')) {
        return;
      }
      // Skip if it contains an iframe (preserve pop-up infrastructure)
      if (container.querySelector('iframe')) {
        return;
      }
      // Skip Gorgias chat widget elements (don't interfere with chat positioning)
      if (container.closest('[id*="gorgias"], [class*="gorgias"], [data-gorgias]')) {
        return;
      }
      if (container.id && container.id.toLowerCase().includes('gorgias')) {
        return;
      }
      
      // Only process DIV elements that look like the floating button
      if (container.tagName === 'DIV') {
        const hasNotifyText = (container.textContent || '').toUpperCase().includes('NOTIFY') ||
                             (container.textContent || '').toUpperCase().includes('BACK IN STOCK');
        
        if (hasNotifyText) {
          // Make it nearly invisible but keep it in place and functional
          // Keep original position, just make it almost transparent
          container.style.opacity = '0.01'; // Nearly invisible but still "visible" to the app
          container.style.pointerEvents = 'auto'; // Keep it clickable
          container.style.transition = 'opacity 0.3s ease';
          // Don't change position - keep it where the app expects it
          container.setAttribute('data-dimmed-by-notify-script', 'true');
        }
      }
    });
  } catch (e) {
    console.error('NotifyWhenAvailable: Error dimming floating buttons', e);
  }
  }

  /**
   * @param {any} variant - The variant object (optional)
   * @param {any} eventTarget - The event target element (optional)
   */
  function updateButtonVisibility(variant = null, eventTarget = null) {
  // Determine context: are we in the quick add modal or main page?
  let context = document;
  
  // Check if the event came from within the quick add modal
  if (eventTarget && typeof eventTarget.closest === 'function') {
    const modal = eventTarget.closest('#quick-add-modal-content') || eventTarget.closest('quick-add-dialog');
    if (modal) {
      context = modal;
    }
  }
  
  // Try to find elements within the correct context
  let notifyButton = context.querySelector('#BIS_trigger');
  let addToCartButton = context.querySelector('[name="add"]');
  let addToCartContainer = context.querySelector('add-to-cart-component');
  
  // Fallback to document-level search if not found in context
  if (!notifyButton) {
    notifyButton = document.getElementById('BIS_trigger');
  }
  if (!addToCartButton) {
    addToCartButton = document.querySelector('[name="add"]');
  }
  if (!addToCartContainer) {
    addToCartContainer = document.querySelector('add-to-cart-component');
  }

  if (!notifyButton) {
    return;
  }

  let isAvailable = true;

  // Try to get variant data from multiple sources for faster detection
  if (variant && typeof variant.available !== 'undefined') {
    // We have explicit variant data (fastest)
    isAvailable = variant.available;
    notifyButton.setAttribute('data-variant-id', variant.id);
  } else {
    // Fast fallback: check add to cart button state
    // The theme updates this, but we need to check multiple indicators
    if (addToCartButton) {
      // Check multiple ways the button might indicate availability
      const isDisabled = addToCartButton.disabled || addToCartButton.hasAttribute('disabled');
      const isHidden = addToCartButton.style.display === 'none' || 
                      addToCartButton.classList.contains('hidden') ||
                      addToCartButton.hasAttribute('hidden');
      const computedDisplay = window.getComputedStyle(addToCartButton).display;
      const isVisible = computedDisplay !== 'none';
      
      // Also check the container
      const containerHidden = addToCartContainer && (
        addToCartContainer.style.display === 'none' ||
        addToCartContainer.classList.contains('hidden') ||
        addToCartContainer.hasAttribute('hidden')
      );
      
      // PRIORITY: If button is NOT disabled, variant is likely available
      // The disabled state is the most reliable indicator from the theme
      // Even if button is hidden (by us or theme), if it's not disabled, it's available
      if (!isDisabled) {
        // Button is enabled - variant is available
        isAvailable = true;
      } else {
        // Button is disabled - variant is not available
        isAvailable = false;
      }
      
      // Also try to get variant ID from the form input for data attribute
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        notifyButton.setAttribute('data-variant-id', variantInput.value);
      }
      
      // If button is enabled but still hidden, it might be transitioning
      // Retry to ensure we show it properly
      if (isAvailable && (isHidden || !isVisible)) {
        // Button should be visible but isn't - retry after theme updates
        setTimeout(() => {
          const retryDisabled = addToCartButton.disabled || addToCartButton.hasAttribute('disabled');
          if (!retryDisabled) {
            updateButtonVisibility();
          }
        }, 150);
      }
    }
  }

  // IMMEDIATE button visibility changes (no delays)
  if (isAvailable) {
    // Product available - show add to cart IMMEDIATELY, hide notify IMMEDIATELY
    // Show add to cart button FIRST (most important for user experience)
    if (addToCartButton) {
      addToCartButton.disabled = false;
      addToCartButton.removeAttribute('disabled');
      addToCartButton.style.display = '';
      addToCartButton.classList.remove('hidden');
      addToCartButton.removeAttribute('hidden');
      // Force reflow to ensure display change is immediate
      addToCartButton.offsetHeight;
    }

    if (addToCartContainer) {
      addToCartContainer.style.display = '';
      addToCartContainer.classList.remove('hidden');
      addToCartContainer.removeAttribute('hidden');
      addToCartContainer.offsetHeight; // Force reflow
    }
    
    // Hide notify button
    notifyButton.style.display = 'none';
    notifyButton.classList.add('hidden');
    
    // Don't call hideFloatingNotifyButtons when showing add to cart (not needed, saves time)
  } else {
    // Product NOT available - show notify IMMEDIATELY, hide add to cart IMMEDIATELY
    // Show notify button FIRST
    notifyButton.style.display = 'block';
    notifyButton.classList.remove('hidden');
    notifyButton.offsetHeight; // Force reflow
    
    // Hide add to cart button
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.style.display = 'none';
    }

    if (addToCartContainer) {
      addToCartContainer.style.display = 'none';
    }
    
    // Move floating button off-screen asynchronously (don't block UI update)
    // Use setTimeout with 0ms to run after current execution but still very fast
    setTimeout(() => {
      hideFloatingNotifyButtons();
    }, 0);
  }
}

  // Export for debugging
  window.NotifyWhenAvailable = {
    updateButtonVisibility,
    init
  };
}
